import { axiosInstance } from "@/lib/axiosInstance";

export interface ProfileType {
  id: string;
  industry: string | null;
  company_size: string | null;
  description: string | null;
  headquarters: string | null;
  founded_year: number | null;
  created_at: string;
  updated_at: string;
}

export interface ProfileUpdateType {
  industry?: string;
  company_size?: string;
  description?: string;
  headquarters?: string;
  founded_year?: number;
}

export const fetchProfile = async (): Promise<ProfileType> => {
  const res = await axiosInstance.get("/v1/profile");
  return res.data;
};

export const updateProfile = async (data: ProfileUpdateType): Promise<ProfileType> => {
  const res = await axiosInstance.put("/v1/profile", data);
  return res.data;
};
